import { ChannelSelectForm } from "../channel_dropdown";
import { useChannels } from "./hooks/use_channels";

export enum RequiredPermission {
	Read,
	Write,
}

export default function ChannelPicker(props: {
	channel_id: string | undefined;
	setChannel: (included_channel: string | null) => void;
	name?: string | JSX.Element;
	description?: string;
	hasUnsavedChanges?: boolean;
}) {
	const channels = useChannels();

	return (
		<ChannelSelectForm
			name={props.name}
			info={props.description}
			initial_value={
				channels.find((val) => val.id === props.channel_id) ??
				channels[0]
			}
			update_initially={true}
			channel_data={channels}
			disabled={false}
			updateFunc={(val) => {
				props.setChannel(val.id);
			}}
			include_threads={true}
			has_unsaved_changes={props.hasUnsavedChanges}
		/>
	);
}
